import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { resumeSlice } from "../app/modules/Resume/_redux/resumeSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  resume: resumeSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
